import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useOrganizacion } from '../context/OrganizacionContext';
import EvaluacionDinamica from '../components/EvaluacionDinamica';

const EvaluacionLiderDinamica = () => {
  const [evaluacionData, setEvaluacionData] = useState(null);
  const navigate = useNavigate();
  const { config, logoUrl } = useOrganizacion();

  useEffect(() => {
    // Obtener datos de la evaluación desde localStorage
    const data = localStorage.getItem('evaluacionData');
    if (!data) {
      toast.error('No se encontraron datos de evaluación. Redirigiendo...');
      navigate('/login-unificado');
      return;
    }

    const parsedData = JSON.parse(data);
    if (parsedData.evaluador.user_type !== 'empleado') {
      toast.error('Acceso no autorizado para este tipo de evaluación');
      navigate('/login-unificado');
      return;
    }

    setEvaluacionData(parsedData);
  }, [navigate]);

  if (!evaluacionData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando datos de evaluación...</p>
        </div>
      </div>
    );
  }

  return (
    <EvaluacionDinamica
      tipoEvaluacion="empleado_lider"
      evaluadorId={evaluacionData.evaluador.user_id}
      evaluadoId={evaluacionData.evaluado.id}
      evaluadorInfo={{
        nombre: evaluacionData.evaluador.user_name,
        cargo: evaluacionData.evaluador.cargo
      }}
      evaluadoInfo={{
        nombre: evaluacionData.evaluado.nombre,
        cargo: evaluacionData.evaluado.cargo
      }}
    />
  );
};

export default EvaluacionLiderDinamica;